/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetLicenseFeatureAccessModules$Request {
    licenseId: number;
}

export interface GetLicenseFeatureAccessModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseFeatureAccessModulesRequest = createAction<PayloadData<void, GetLicenseFeatureAccessModules$Request>>('GET_LICENSE_FEATURE_ACCESS_MODULES__GET_LICENSE_FEATURE_ACCESS_MODULES__REQUEST');
export const getLicenseFeatureAccessModulesSuccess = createAction<PayloadData<Array<DictionaryItem>, GetLicenseFeatureAccessModules$Request>>('GET_LICENSE_FEATURE_ACCESS_MODULES__GET_LICENSE_FEATURE_ACCESS_MODULES__SUCCESS');
export const getLicenseFeatureAccessModulesFailure = createAction<PayloadData<Error, GetLicenseFeatureAccessModules$Request, true>>('GET_LICENSE_FEATURE_ACCESS_MODULES__GET_LICENSE_FEATURE_ACCESS_MODULES__FAILURE');

export const getLicenseFeatureAccessModulesActions = [
    getLicenseFeatureAccessModulesRequest,
    getLicenseFeatureAccessModulesSuccess,
    getLicenseFeatureAccessModulesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseFeatureAccessModules = (meta: GetLicenseFeatureAccessModules$Request, config?: GetLicenseFeatureAccessModules$Config) => {
    return {
        CALL_API: {
            types: getLicenseFeatureAccessModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/licenses/${meta.licenseId}/feature-access-module`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

